// extracted by mini-css-extract-plugin
export var avatarContainer = "_5l-1";
export var largeAvatarContainer = "_5l-2";
export var smallAvatarContainer = "_5l-0";